module.exports = __webpack_public_path__ + "static/img/analyzeBg.e2934fe6.png";